/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Field_Assignee_UnassignedInputs */

const en_task_field_assignee_unassigned = /** @type {(inputs: Task_Field_Assignee_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unassigned`)
};

const pt_br2_task_field_assignee_unassigned = /** @type {(inputs: Task_Field_Assignee_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem responsável`)
};

/**
* | output |
* | --- |
* | "Unassigned" |
*
* @param {Task_Field_Assignee_UnassignedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_field_assignee_unassigned = /** @type {((inputs?: Task_Field_Assignee_UnassignedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Field_Assignee_UnassignedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_field_assignee_unassigned(inputs)
	return pt_br2_task_field_assignee_unassigned(inputs)
});